import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 7.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm4.5-3a3 3 0 100 6 3 3 0 000-6zM7.5 15a3 3 0 00-3 3v3H3v-3a4.5 4.5 0 014.5-4.5H17V15H7.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 7.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm4.5-3a3 3 0 100 6 3 3 0 000-6zM7.5 15a3 3 0 00-3 3v3H3v-3a4.5 4.5 0 014.5-4.5H17V15H7.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 15a9 9 0 1118 0 9 9 0 01-18 0zm9-6a6 6 0 100 12 6 6 0 000-12zm-9 21a6 6 0 00-6 6v6H6v-6a9 9 0 019-9h19v3H15z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 34l-16.82 7.135c-1.4.594-2.579.89-3.528.89-1.068 0-1.846-.376-2.324-1.129-.62-.97-.35-2.532.714-4.18.631-.964 1.434-1.848 2.216-2.694-.184.299-1.808 3.001-.032 4.274.351.255.85.38 1.465.38.494 0 1.06-.08 1.682-.242L45 34z",
    clipRule: "evenodd"
  }))
};
export var ProfileSwoosh = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});